<div ngbDropdown [placement]="'right'" class="sidenav-user dropdown">
  <div ngbDropdownToggle class="user-dropdown">
    <div class="profile-label">
      <div class="avatar">
        <div class="avatar-initials">{{ userInitials() }}</div>
      </div>
      <div class="menu-parent">
        <div class="menu">{{ userName() }}</div>
        <div class="menu2">{{ userRoleLabel() }}</div>
      </div>
    </div>
    <span class="menu-arrow">
      <ng-icon name="tablerChevronDown"></ng-icon>
    </span>
  </div>
  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menulist">
    <div class="profile-label">
      <div class="avatar">
        <div class="avatar-initials">{{ userInitials() }}</div>
      </div>
      <div class="menu-parent">
        <div class="menu">{{ userName() }}</div>
        <div class="menu2">{{ userRoleLabel() }}</div>
      </div>
    </div>

    <div class="separator"></div>

    <div class="dropdown-menulist-dropdown-list">
      <div class="dropdown-list">
        <div
          class="dropdown-menu-element4"
          appClickOutside
          (clickOutside)="closeLanguageDropdown()"
        >
          <div #languageButton class="general-list-element" (click)="toggleLanguageDropdown()">
            <div class="elements">
              <div class="main">
                <img src="assets/icons/language.svg" class="language-icon" alt="language" />
                <div class="menu9">{{ languageLabel() }}</div>
              </div>
              <img src="assets/icons/chevron-right.svg" class="language-icon" alt="chevron" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="separator"></div>

    <div class="dropdown-list3">
      <div class="dropdown-list">
        <div class="dropdown-menu-element5">
          <a
            routerLink="/settings"
            class="general-list-element text-decoration-none text-body d-block"
          >
            <div class="elements2">
              <div class="main">
                <ng-icon name="tablerSettings" class="language-icon" />
                <div class="menu9">{{ 'menu.settings' | transloco }}</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="separator"></div>

    @if (showSecurityMenu) {
      <div class="dropdown-list3">
        <div class="dropdown-list">
          <div class="dropdown-menu-element5">
            <a
              routerLink="/security"
              class="general-list-element text-decoration-none text-body d-block"
            >
              <div class="elements2">
                <div class="main">
                  <ng-icon name="tablerShieldLock" class="language-icon" />
                  <div class="menu9">{{ 'menu.security' | transloco }}</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="separator"></div>
    }

    <div class="dropdown-list3">
      <div class="dropdown-list">
        <div class="dropdown-menu-element5">
          <div class="general-list-element" (click)="logout()">
            <div class="elements2">
              <div class="main">
                <img src="assets/icons/logout.svg" class="language-icon" alt="logout" />
                <div class="menu9">{{ logoutLabel() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (languageDropdownOpen()) {
  <div
    class="language-submenu-portal"
    [style.top]="submenuPosition().top"
    [style.left]="submenuPosition().left"
  >
    <div class="language-submenu-list">
      @for (lang of availableLanguages; track lang.code) {
        <div
          class="language-menu-element"
          [class.language-menu-element-active]="currentLang().code === lang.code"
          (click)="changeLanguage(lang.code)"
        >
          <div class="language-general-list-element">
            <div class="language-elements">
              <div class="language-main">
                <div class="language-menu">{{ lang.nativeName }}</div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
